// Prezzi come li scrive e li legge un operatore italiano.

// Un importo scritto a mano: accetta la virgola («25,50») e il punto («25.50»),
// anche con il separatore delle migliaia («1.250,00»). Vuoto o non valido = NaN.
export function numeroDaTesto(valore) {
    if (typeof valore === 'number') return valore;
    if (valore === null || valore === undefined) return NaN;
    let s = String(valore).replace(/[€\s]/g, '');
    if (s === '') return NaN;
    if (s.includes(',')) s = s.replace(/\./g, '').replace(',', '.');
    return /^-?\d+(\.\d+)?$/.test(s) ? Number(s) : NaN;
}

// «€ 25,50»; senza importo (null, vuoto o zero con conZero=false) un trattino.
export function formattaPrezzo(valore, { conZero = true } = {}) {
    const n = numeroDaTesto(valore);
    if (Number.isNaN(n) || (!conZero && n === 0)) return '—';
    return '€ ' + n.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

// I campi importo che il server vuole come numero.
const CAMPI_IMPORTO = ['standard_price', 'member_price', 'federated_price', 'price', 'fitcoin_cashback', 'list_price'];

// Converte in numero gli importi scritti come testo, dentro il corpo di una
// richiesta (anche in elenchi e oggetti annidati). Restituisce lo stesso
// oggetto se non c'è niente da cambiare.
export function importiInNumeri(dati, profondita = 0) {
    if (!dati || typeof dati !== 'object' || profondita > 4) return dati;
    if (Array.isArray(dati)) {
        let cambiato = false;
        const nuovo = dati.map(el => {
            const n = importiInNumeri(el, profondita + 1);
            if (n !== el) cambiato = true;
            return n;
        });
        return cambiato ? nuovo : dati;
    }
    if (typeof FormData !== 'undefined' && dati instanceof FormData) return dati;
    let copia = null;
    for (const chiave of Object.keys(dati)) {
        const v = dati[chiave];
        let n = v;
        if (CAMPI_IMPORTO.includes(chiave) && typeof v === 'string' && v.trim() !== '') {
            const numero = numeroDaTesto(v);
            if (!Number.isNaN(numero)) n = numero;
        } else if (v && typeof v === 'object') {
            n = importiInNumeri(v, profondita + 1);
        }
        if (n !== v) {
            if (!copia) copia = { ...dati };
            copia[chiave] = n;
        }
    }
    return copia || dati;
}

// Un importo da mettere in un campo modificabile: «55,50» (vuoto se manca).
export function prezzoPerCampo(valore) {
    const n = numeroDaTesto(valore);
    if (Number.isNaN(n)) return '';
    return n.toLocaleString('it-IT', { minimumFractionDigits: 2, maximumFractionDigits: 2, useGrouping: false });
}
